import { Row } from 'react-bootstrap';

import * as string from 'common/string';

function TitleDescription({
  branding,
}: {
  branding: {
    logoImageURL: string;
    titleCopy: string;
    descriptionCopy: string;
  };
}) {
  return (
    <Row className="flex-column m-0 multi__campaign__content">
      <div className="subscribe__content__title">
        {string.replacePlaceholders(branding.titleCopy, branding)}
      </div>
      <div className="subscribe__property__content__description">
        {branding.descriptionCopy}
      </div>
    </Row>
  );
}

export default TitleDescription;
